module.exports = __webpack_public_path__ + "2Tcn8aMv.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clock-blue.png
// module id = ./src/img/clock-blue.png
// module chunks = main